export enum ProductTableNameEnum {
  Water = 'water',
  Heating = 'heating',
  Sewage = 'sewage',
  Reguard = 'reguard',
  Resource = 'resource',
  TemperatureRegulator = 'temperatureRegulator',
}
